<template>
  <div class="open-index-main">
    <div class="container">
      <div class="left">
        <div
          class="flfg item pointer"
          :style="{ background: docType == 1 ? '#2468f2' : '#fff' }"
          @click="changeActive(0)"
        >
          <img src="../assets/images/law.png" alt="" v-if="docType == 1" />
          <img src="../assets/images/law1.png" alt="" v-else />
          <span :style="{ color: docType == 1 ? '#fff' : '#454A5B' }"
            >法律法规</span
          >
        </div>
        <div
          class="bzgf item pointer"
          :style="{ background: docType == 2 ? '#2468f2' : '#fff' }"
          @click="changeActive(1)"
        >
          <img src="../assets/images/rule.png" alt="" v-if="docType == 2" />
          <img src="../assets/images/rule1.png" alt="" v-else />
          <span :style="{ color: docType == 2 ? '#fff' : '#454A5B' }"
            >标准规范</span
          >
        </div>
      </div>
      <div class="right">
        <div class="title">
          <div class="info">{{ docType == 1 ? "法律法规" : "标准规范" }}</div>
        </div>
        <SmartTable
          :custom="true"
          :fetch="fetch"
          :beforeFetch="beforeFetch"
          :afterFetch="afterFetch"
          ref="smart-table"
        >
          <template slot-scope="scope">
            <div class="el-table" v-if="scope.$data.length === 0">
              <div
                v-if="scope.$data.length === 0"
                class="el-table__empty-block"
              >
                <span class="el-table__empty-text">暂无数据</span>
              </div>
            </div>
            <div
              v-for="(item, index) in scope.$data"
              :key="item.id"
              class="flfg-bzgf-items"
            >
              <div class="smart-table-item">
                <div
                  class="info ell"
                  @click="yulan(item)"
                  :title="item.docName"
                >
                  {{ item.docName }}
                </div>
                <div class="time">{{ time8(item.publishTime) }}</div>
                <div class="download" @click="download(item)">下载</div>
              </div>
            </div>
          </template>
        </SmartTable>
      </div>
    </div>
  </div>
</template>

<script>
import SmartTable from "../../../common/components/smart-table.vue";
import { CONTEXTPATH } from "../service/index";
import time8 from "../utils/time8";
import _get from "lodash.get";
import axios from "axios";
export default {
  name: "Main",
  components: {
    SmartTable,
  },
  data() {
    return {
      docType: 1,
      time8,
      CONTEXTPATH,
    };
  },
  methods: {
    async download(item) {
      if (item.docAuthority == "0") {
        if (item.isDownload == "1") {
          window.open(
            `${CONTEXTPATH}/document/documentDownload?docType=${item.docType}&id=${item.id}`
          );
        } else {
          this.$message.warning("暂不允许下载");
        }
      } else {
        this.$service.getUserInfo().then((res) => {
          if (!res.status) {
            this.$message.warning("请先登录");
            return;
          } else {
            if (item.isDownload == "1") {
              window.open(
                `${CONTEXTPATH}/document/documentDownload?docType=${item.docType}&id=${item.id}`
              );
            } else {
              this.$message.warning("暂不允许下载");
            }
          }
        });
      }
    },
    yulan(item) {
      const arr = ['doc','docx','pdf','xls','xlsx']
      axios({
        url: `${CONTEXTPATH}/document/documentPreview?docType=${item.docType}&id=${item.id}`,
      }).then((res) => {
        if (!res.data.flag) {
          this.$message.warning(res.data.errMsg);
          return;
        }
        let split = res.data.data.split('.')
        let type = split[split.length-1]
        if(arr.includes(type.toLowerCase())) {
          window.open(res.data.data);
        }else {
          this.$message.warning('该类型暂不支持预览')
        }
      });
    },
    changeActive(index) {
      this.docType = index + 1;
      this.$refs["smart-table"].reload(1);
    },
    fetch(url, params) {
      this.$loading(true);
      return this.$service.documentPage(params);
    },
    beforeFetch(pageSize, pageNo) {
      return {
        pageSize,
        pageNum: pageNo,
        docType: this.docType,
      };
    },
    afterFetch(response, intendedPageSize, intendedPageNo) {
      this.$loading(false);
      return {
        data: _get(response, "data.rows", []),
        total: _get(response, "data.total", 0),
        pageSize: intendedPageSize,
        pageNo: intendedPageNo,
      };
    },
  },
};
</script>

<style lang="less" scoped>
.pointer {
  cursor: pointer;
}
.ell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.open-index-main {
  flex-grow: 1;
  width: 100%;
  background-color: #f4f6f8;
  .container {
    display: flex;
    width: 1100px;
    margin: 24px auto 56px;
    .left {
      width: 200px;
      margin-right: 24px;
      background-color: #fff;
      padding: 20px 20px 0;
      .item {
        margin-bottom: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 48px;
        border-radius: 4px;
        img {
          margin-right: 16px;
        }
      }
    }
    .right {
      padding: 24px 24px 20px;
      flex: 1;
      background-color: #fff;
      .title {
        padding-bottom: 24px;
        border-bottom: 1px solid #dbdee6;
        .info {
          font-size: 18px;
          font-weight: 500;
          color: #454a5b;
        }
      }
      .smart-table-item {
        width: 100%;
        height: 56px;
        display: flex;
        align-items: center;
        padding: 0 24px;
        .info {
          cursor: pointer;
          max-width: 429px;
          flex: 1;
          font-size: 14px;
          font-weight: 500;
          color: #454a5b;
        }
        .time {
          margin-left: 51px;
          margin-right: 164px;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
        }
        .download {
          cursor: pointer;
          width: 58px;
          height: 29px;
          border-radius: 15px;
          border: 1px solid #2468f2;
          font-size: 14px;
          font-weight: 500;
          color: #2468f2;
          text-align: center;
          line-height: 29px;
        }
      }
    }
  }
}
.flfg-bzgf-items {
  background-color: #eff3fb;
  margin-bottom: 8px;
  border-radius: 4px;
}
.flfg-bzgf-items:first-child {
  margin-top: 15px;
}
</style>
